export { ClickableSlide } from "./clickable-slide";
